module.exports = __webpack_public_path__ + "img/people.37efba6f.svg";